export default "__VITE_ASSET__CvyqT_KT__"